import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Container } from "@pixi/react";
import LineWinTextController from "../../../Components/Animations/LineWinText/LineWinTextController";
import { safeInit } from "../../../utilities";

export const LineWinTextSymbol = forwardRef(
  ({ index, y, symbolWidth, symbolHeight }, ref) => {
    const containerRef = useRef(null);
    const controllerRef = useRef(null);

    // Initialize controller when container is ready (after render completes)
    useEffect(() => {
      if (containerRef.current && !controllerRef.current) {
        safeInit(() => {
          controllerRef.current = new LineWinTextController(
            containerRef.current,
            symbolWidth,
            symbolHeight
          );
        });
      }

      return () => {
        if (controllerRef.current) {
          controllerRef.current.cleanup();
          controllerRef.current = null;
        }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Handle dimension changes
    useEffect(() => {
      if (controllerRef.current && symbolWidth && symbolHeight) {
        controllerRef.current.updateDimensions(symbolWidth, symbolHeight);
      }
    }, [symbolWidth, symbolHeight]);

    // Expose methods directly via useImperativeHandle (same pattern as GlobalLineWinText)
    useImperativeHandle(ref, () => ({
      showWinAmount: (amount) => {
        controllerRef.current?.showWinAmount(amount);
      },
      hide: () => {
        controllerRef.current?.hide();
      },
      // Also expose getLineWinTextRef for backward compatibility
      getLineWinTextRef: () => ({
        showWinAmount: (amount) => {
          controllerRef.current?.showWinAmount(amount);
        },
        hide: () => {
          controllerRef.current?.hide();
        },
      }),
    }));

    return (
      <Container
        ref={containerRef}
        y={y}
        x={0}
        zIndex={20}
        sortableChildren
        name={`line_win_text_symbol_${index}`}
      />
    );
  }
);

export default LineWinTextSymbol;
